export const RecentFiles = ['get:users/recent-files'];